/** Shared timings: header full/mini logo shuffle + hero stacked logo shuffle. */
export const LOGO_ANIM_INTERVAL_MS = 3000;
export const LOGO_ANIM_FADE_MS = 250;
export const LOGO_ANIM_SLIDE_MS = 350;
